import { createContext } from 'react';

export const UserLoginButton = createContext<JSX.Element | null | undefined>(undefined);
